export const authenticationConstants = {
    LOGGED_IN: 'LOGGED_IN',
    LOG_OUT: 'LOG_OUT'
};
